<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Upload Publications</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row">
        <div class="col mt-10">
          <file-drop
            id="logfiles1"
            v-on:update="logFiles($event)"
            :fileName="fileName"
          ></file-drop>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Size</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in files" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td>{{ item.sizeMB }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="float-right action-area">
            <v-btn
              class="mr-4"
              color="primary"
              @click="onNext()"
              :loading="loading"
              :disabled="loading"
              id="btnNext"
            >
              Next
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import FileDrop from "../../components/FileDrop";

export default {
  name: "PubPublications",
  components: {
    Notification,
    FileDrop,
  },
  methods: {
    logFiles(fileList) {
      this.files = fileList;

      for (let i = 0; i < this.files.length; i++) {
        this.files[i].sizeMB =
          (this.files[i].size / (1024 * 1024)).toFixed(2).toString() + " MB";
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        console.log(" result " + e);

        const text = reader.result.toString().trim();
        this.file = text;
      };
      this.fileSize = 0;
      reader.readAsDataURL(fileList[0]);
      this.fileName = fileList[0].name;
      console.log(this.fileName);
      console.log(fileList[0].size);

      this.fileSize = (fileList[0].size / (1024 * 1024)).toFixed(2);
    },
    onNext(){

    }
  },
  data: () => ({
    notify: {
      type: 0,
      message: "",
      errors: [],
    },
    fileName: "",
    files: [],
  }),
};
</script>


// WEBPACK FOOTER //
// src/views/publisher/PubPublications.vue